// src/hooks/use-sidebar-collapsed.ts
import { useState, useEffect } from 'react';

const STORAGE_KEY = 'ufficio-stile-sidebar-collapsed';

export function useSidebarCollapsed() {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    // Inizializza dal localStorage se disponibile
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored === 'true';
    }
    return false;
  });

  useEffect(() => {
    // Persisti in localStorage quando cambia
    localStorage.setItem(STORAGE_KEY, String(isCollapsed));
  }, [isCollapsed]);

  const toggleCollapsed = () => {
    setIsCollapsed((prev) => !prev);
  };

  return {
    isCollapsed,
    setIsCollapsed,
    toggleCollapsed,
  };
}
